import { useLayoutEffect } from 'react';
import {
  applyOrgBrandingFromUser,
  bootstrapOrgBrandingForPublicPages,
} from '../../utils/orgBranding';

/**
 * Applies org chrome/accent tokens on :root for login, auth, public, and app routes.
 * Do not listen for ORG_BRANDING_EVENT here — applyOrgBranding dispatches that event,
 * which would recurse and freeze the UI (including Sign In).
 */
export default function OrgBrandingApplier() {
  useLayoutEffect(() => {
    let cancelled = false;

    const apply = async () => {
      try {
        const raw = sessionStorage.getItem('user');
        const user = raw ? JSON.parse(raw) : null;
        if (user?.org_branding) {
          if (!cancelled) applyOrgBrandingFromUser(user);
          return;
        }
      } catch {
        /* fall through */
      }
      if (!cancelled) {
        await bootstrapOrgBrandingForPublicPages();
      }
    };

    apply();
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
